var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.416 8l6.292-6.292A1 1 0 1014.293.293L8 6.585 1.708.293A1 1 0 10.293 1.708L6.586 8 .293 14.292a1 1 0 101.415 1.415l6.293-6.292 6.292 6.292a.998.998 0 001.415 0 1 1 0 000-1.415L9.416 8z","fill":"#263238"}));
}

CloseIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
